import React, { memo } from 'react';

import { makeStyles } from '@mui/styles';
import SvgIcon from '@mui/material/SvgIcon';

const useStyles = makeStyles({
  icon: {
    width: '1.5rem',
    height: '1.5rem',
    fillOpacity: '0.87',
  },
});

const MenuIcon = () => {
  const styles = useStyles();

  return (
    <SvgIcon viewBox="0 0 24 24" className={styles.icon} fill="white">
      <path d="M0.921356 20.25H8.92136V17.5H0.921356V20.25ZM0.921356 3.75V6.5H24.9214V3.75H0.921356ZM0.921356 13.375H16.9214V10.625H0.921356V13.375Z" />
    </SvgIcon>
  );
};

export default memo(MenuIcon);
